import { Axios } from '@src/context/Api/includes/Axios/Axios';
import { logger } from '@src/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';
import { isUndefined } from 'lodash';

/**
 * ListSearchResults
 *
 * Makes a request to the remote API to fetch search results.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListSearchResults = async (payload = {}) => {
  try {
    const requestArgs = {
      baseURL: config('API_URL'),
      data: {},
      headers: {
        'x-api-endpoint': '/search',
      },
      method: 'POST',
      params: {},
    };

    if (!isUndefined(payload)) {
      requestArgs.params = { ...{ queryKey: payload[0] } };
    }

    if (!isUndefined(payload)) {
      requestArgs.params = { ...{ queryKey: payload[0] }, ...payload[1] };
      requestArgs.data = { ...payload[1] };
    }

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse?.data;
  } catch (error) {
    logger.error('src/requests/queries/ListSearchResults.js -> ListSearchResults', false, error);

    throw error;
  }
};
